module.exports = __webpack_public_path__ + "img/gallery-cookie.50263b67.png";